// needed for row & cell level scope DnD setup
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Header, flexRender, Table } from "@tanstack/react-table";
import PanToolIcon from "@mui/icons-material/PanTool";
import { IconButton } from "@mui/material";
import classes from "./DraggableTableHeader.module.scss";
import {
  TiArrowSortedUp,
  TiArrowSortedDown,
  TiArrowUnsorted,
} from "react-icons/ti";
import { CSSProperties, useEffect } from "react";
import { Filter } from "../filter/Filter";
import { colorSelect } from "../../../commons/columnColor";
// type Post = {
//   userId: number;
//   id: number;
//   title: string;
//   body: string;
//   url: Array<Url>;
// };
type Url = {
  name: string;
  url: string;
};
export const DraggableTableHeader = ({
  header,
  table,
  setIsPending,
}: {
  header: Header<any, any>;
  table: Table<any>;
  setIsPending: (value: boolean) => void;
}) => {
  const { attributes, isDragging, listeners, setNodeRef, transform } =
    useSortable({
      id: header.column.id,
    });
  // console.log("headerSize", header.column.getSize());

  const colorStyle = colorSelect(header.column.columnDef.id ?? "");
  // console.log(colorStyle);
  const styleBase: CSSProperties = {
    opacity: isDragging ? 0.8 : 1,
    position: "relative",
    transform: CSS.Translate.toString(transform), // translate instead of transform to avoid squishing
    transition: "width transform 0.2s ease-in-out",
    whiteSpace: "nowrap",
    width: header.column.getSize(),
    maxWidth: header.column.getSize(),
    minWidth: header.column.getSize(),

    zIndex: isDragging ? 1 : 0,
  };
  // const styleProcess: CSSProperties = {
  //   opacity: isDragging ? 0.8 : 1,
  //   position: "relative",
  //   transform: CSS.Translate.toString(transform), // translate instead of transform to avoid squishing
  //   transition: "width transform 0.2s ease-in-out",
  //   whiteSpace: "nowrap",
  //   width: header.column.getSize(),
  //   maxWidth: header.column.getSize(),
  //   minWidth: header.column.getSize(),
  //   color: "#5865F2",
  //   zIndex: isDragging ? 1 : 0,
  // };
  useEffect(() => {
    setIsPending(isDragging);
  }, [isDragging]);
  return (
    <th colSpan={header.colSpan} ref={setNodeRef} style={styleBase}>
      <div className={classes.headerContents} {...attributes} {...listeners}>
        {/* <div className={classes.headers} {...attributes} {...listeners}> */}
        <div
          className={classes.headers}
          onClick={header.column.getToggleSortingHandler()}
        >
          <div className={classes.dragIcon}>
            <PanToolIcon
              sx={
                colorStyle === "base"
                  ? { fontSize: "16px", color: "#0adcc0" }
                  : colorStyle === "processPt"
                  ? { fontSize: "16px", color: "#09A0F2" }
                  : colorStyle === "processPv"
                  ? { fontSize: "16px", color: "#FF5ECD" }
                  : { fontSize: "16px", color: "#ffdb5e" }
              }
            />
          </div>
          {/* {header.isPlaceholder
          ? null
          : flexRender(header.column.columnDef.header, header.getContext())} */}
          <div
            className={classes.title}
            style={
              colorStyle === "base"
                ? { color: "#0adcc0" }
                : colorStyle === "processPt"
                ? { color: "#09A0F2" }
                : colorStyle === "processPv"
                ? { color: "#FF5ECD" }
                : { color: "#ffdb5e" }
            }
          >
            {flexRender(header.column.columnDef.header, header.getContext())}
          </div>
          <div
            className={classes.sortIcon}
            style={
              colorStyle === "base"
                ? { color: "#0adcc0" }
                : colorStyle === "processPt"
                ? { color: "#09A0F2" }
                : colorStyle === "processPv"
                ? { color: "#FF5ECD" }
                : { color: "#ffdb5e" }
            }
          >
            {{
              asc: <TiArrowSortedUp />,
              desc: <TiArrowSortedDown />,
            }[header.column.getIsSorted() as string] ?? <TiArrowUnsorted />}
          </div>
        </div>
        <div className={classes.filters}>
          {header.column.getCanFilter() ? (
            <div>
              <Filter column={header.column} table={table} header={header} />
            </div>
          ) : (
            <div>
              <input className={classes.defaultInput} disabled></input>
            </div>
          )}
        </div>
      </div>
    </th>
  );
};
